module.exports = __webpack_public_path__ + "static/media/arrow_6.18c0ff62.svg";